require('./angular-aria');
module.exports = 'ngAria';



//////////////////
// WEBPACK FOOTER
// ./~/angular-aria/index.js
// module id = 986
// module chunks = 2